import {MutationTree} from 'vuex'
import {mutationType} from '@/store/modules/views/role/mutation-types'
import PermissionState, {IPermission} from '@/store/modules/views/permission/states'
const mutations: MutationTree<PermissionState> = {
  [mutationType.GET_LISTS](
    state: PermissionState,
    data: IPermission,
  ): void {
    state.list = data
  },
}

export default mutations
